export const snapshotRouteForPerformance = (route = {}) => ({
  name: route.name,
  path: route.path,
  fullPath: route.fullPath,
  matched: Array.isArray(route.matched)
    ? route.matched.map((entry) => ({ path: entry.path }))
    : [],
  meta: route.meta || {},
});

export const routePerformanceIdentity = (route = {}) =>
  [
    route.fullPath || route.path || "",
    route.name || "",
    ...(Array.isArray(route.matched)
      ? route.matched.map((entry) => entry?.path || "")
      : []),
  ].join("\u0000");

export const createRoutePerformanceTracker = ({
  route = {},
  routeGroup = "",
  createRouteMarker,
  markFallback,
  now = () => globalThis.performance?.now?.() || Date.now(),
} = {}) => {
  let currentRoute = route;
  let marker = null;
  let markerIdentity = "";

  const refresh = (nextRoute = currentRoute) => {
    currentRoute = nextRoute || {};
    markerIdentity = routePerformanceIdentity(currentRoute);
    marker =
      typeof createRouteMarker === "function"
        ? createRouteMarker({
            route: snapshotRouteForPerformance(currentRoute),
            routeGroup,
            startedAt: now(),
          })
        : null;
  };

  const refreshIfChanged = (nextRoute = currentRoute) => {
    if (routePerformanceIdentity(nextRoute || {}) !== markerIdentity) {
      refresh(nextRoute);
    }
  };

  const mark = (metricName, data = {}) => {
    refreshIfChanged(currentRoute);
    if (typeof marker === "function") return marker(metricName, data);
    if (typeof markFallback === "function") {
      return markFallback(metricName, {
        routeGroup,
        ...data,
      });
    }
    return false;
  };

  refresh(currentRoute);

  return {
    mark,
    refresh,
    refreshIfChanged,
  };
};
